import { useState, useMemo, useEffect } from "react";

import { useVisitsBreakdownData } from "../hooks/useVisitsBreakdownData";

import { processSingleModeData, createLegendFromEntries, createChartDataWithVisibility } from "./utils";

const useVisitsBreakdownSingleMode = () => {
    const { data, isLoading } = useVisitsBreakdownData();

    const { lobEntries, availableLobs, lobVisitsData, domainMap, initialLegend } = useMemo(() => {
        const processedData = processSingleModeData(data);
        return {
            ...processedData,
            initialLegend: createLegendFromEntries(processedData.lobEntries),
        };
    }, [data]);

    const [legendItems, setLegendItems] = useState(initialLegend);
    const [selectedLobs, setSelectedLobs] = useState<string[]>([]);

    useEffect(() => {
        setLegendItems(initialLegend);

        if (lobEntries.length > 0 && selectedLobs.length === 0) {
            setSelectedLobs(lobEntries.map((entry) => entry.lob));
        }
    }, [initialLegend, lobEntries, selectedLobs.length]);

    const { visibleChartData, allChartData } = useMemo(
        () => createChartDataWithVisibility(lobEntries, legendItems, data, domainMap),
        [lobEntries, legendItems, data, domainMap],
    );

    return {
        allChartData,
        legendItems,
        visibleChartData,
        setLegendItems,
        selectedLobs,
        setSelectedLobs,
        isLoading,
        availableLobs,
        lobVisitsData,
    };
};

export default useVisitsBreakdownSingleMode;
